import * as React from 'react';
import * as styles from './styles.css';
import cn from 'classnames';
import { UIText2 } from '@cian/ui-kit';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var DesktopInput = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var value = props.value,
      onValueChange = props.onValueChange,
      className = props.className,
      unit = props.unit,
      shouldShowUnit = props.shouldShowUnit,
      placeholder = props.placeholder;
  return /*#__PURE__*/_jsxs("div", {
    ref: ref,
    className: styles['container'],
    children: [/*#__PURE__*/_jsx("input", {
      value: value,
      onBlur: props.onBlur,
      onChange: function onChange(e) {
        return onValueChange(e.target.value);
      },
      maxLength: 4,
      className: cn(styles['input'], className),
      placeholder: placeholder || 'Площадь',
      "data-testid": "area_input"
    }), shouldShowUnit && /*#__PURE__*/_jsx("div", {
      className: styles['field-unit'],
      children: /*#__PURE__*/_jsx(UIText2, {
        children: unit
      })
    })]
  });
});
DesktopInput.displayName = 'DesktopInput';